var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path0, _path1, _rect, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle, _circle2, _polygon, _circle3, _circle4, _line, _line2, _circle5, _circle6, _circle7, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLich(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "l-skull",
    cx: "50%",
    cy: "40%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c8b880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#8a7a50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a2010"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l-socket",
    cx: "40%",
    cy: "35%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffe880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#cc8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    stopColor: "#662200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#110500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l-robe-body",
    cx: "50%",
    cy: "30%",
    r: "65%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2a2010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#12100a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#080604"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l-gold-trim",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8a6820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#e8c060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8a6820"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l-sigil",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#ddaa00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#884400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#220800",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l-orb",
    cx: "40%",
    cy: "35%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fffccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#ffcc44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#884400"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l-glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "l-softglow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 90 130 C 75 145 60 165 55 190 C 52 205 70 218 120 218 C 170 218 188 205 185 190 C 180 165 165 145 150 130 Z",
    fill: "url(#l-robe-body)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 57 195 C 70 208 90 215 120 216 C 150 215 170 208 183 195",
    fill: "none",
    stroke: "url(#l-gold-trim)",
    strokeWidth: 2.5,
    opacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 60 203 C 72 214 92 220 120 220 C 148 220 168 214 180 203",
    fill: "none",
    stroke: "#cc9930",
    strokeWidth: 1,
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 90 130 C 75 145 60 165 55 190 L 70 190 C 72 168 82 148 95 133Z",
    fill: "#1a1508",
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 130 C 165 145 180 165 185 190 L 170 190 C 168 168 158 148 145 133Z",
    fill: "#1a1508",
    opacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 90 130 C 75 145 60 165 57 192",
    fill: "none",
    stroke: "url(#l-gold-trim)",
    strokeWidth: 2,
    opacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 130 C 165 145 180 165 183 192",
    fill: "none",
    stroke: "url(#l-gold-trim)",
    strokeWidth: 2,
    opacity: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 95 128 C 100 145 108 160 112 180 L 128 180 C 132 160 140 145 145 128Z",
    fill: "#1c1a0e",
    opacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 108 128 L 112 195 L 128 195 L 132 128Z",
    fill: "#141208",
    opacity: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 136,
    rx: 10,
    ry: 8,
    fill: "#221a05"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 136,
    rx: 10,
    ry: 8,
    fill: "url(#l-gold-trim)",
    opacity: 0.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 136,
    rx: 6,
    ry: 4.5,
    fill: "#cc9930",
    opacity: 0.7
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 136,
    rx: 2.5,
    ry: 2,
    fill: "#ffe890",
    opacity: 0.8
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 68 120 C 78 108 96 102 120 100 C 144 102 162 108 172 120 L 165 130 C 152 118 136 112 120 112 C 104 112 88 118 75 130Z",
    fill: "#221c0a"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 70 120 C 82 110 98 104 120 102 C 142 104 158 110 170 120",
    fill: "none",
    stroke: "url(#l-gold-trim)",
    strokeWidth: 2.5,
    opacity: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 82,
    width: 16,
    height: 22,
    rx: 3,
    fill: "#9a8850",
    opacity: 0.7
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 68,
    rx: 36,
    ry: 34,
    fill: "url(#l-skull)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 56,
    rx: 28,
    ry: 18,
    fill: "#c0a870",
    opacity: 0.3
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95,
    cy: 76,
    rx: 12,
    ry: 8,
    fill: "#aa9458",
    opacity: 0.5
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145,
    cy: 76,
    rx: 12,
    ry: 8,
    fill: "#aa9458",
    opacity: 0.4
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103,
    cy: 68,
    rx: 13,
    ry: 12,
    fill: "#110500"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103,
    cy: 68,
    rx: 13,
    ry: 12,
    fill: "url(#l-socket)",
    filter: "url(#l-glow)"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103,
    cy: 68,
    rx: 7,
    ry: 6,
    fill: "#ffdd55"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103,
    cy: 68,
    rx: 3,
    ry: 2.5,
    fill: "#ff8800"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137,
    cy: 68,
    rx: 13,
    ry: 12,
    fill: "#110500"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137,
    cy: 68,
    rx: 13,
    ry: 12,
    fill: "url(#l-socket)",
    filter: "url(#l-glow)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137,
    cy: 68,
    rx: 7,
    ry: 6,
    fill: "#ffdd55"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137,
    cy: 68,
    rx: 3,
    ry: 2.5,
    fill: "#ff8800"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 116 80 C 118 85 122 85 124 80 L 120 78Z",
    fill: "#1a0d00",
    opacity: 0.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 85 90 C 90 104 100 112 120 114 C 140 112 150 104 155 90 C 140 98 128 100 120 100 C 112 100 100 98 85 90Z",
    fill: "#9a8040"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 96 L 103 107 L 107 96Z",
    fill: "#ddd0a0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 111 99 L 114 110 L 118 99Z",
    fill: "#ddd0a0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 122 99 L 126 110 L 130 99Z",
    fill: "#ddd0a0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 133 96 L 137 107 L 141 96Z",
    fill: "#ddd0a0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 102 100 L 106 91 L 109 100Z",
    fill: "#c8bc8a",
    opacity: 0.7
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 115 102 L 118 93 L 121 102Z",
    fill: "#c8bc8a",
    opacity: 0.7
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 129 102 L 132 93 L 135 102Z",
    fill: "#c8bc8a",
    opacity: 0.7
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 84 34 C 78 22 74 15 80 8 C 90 0 100 10 104 22 C 94 18 88 24 84 34Z",
    fill: "#1a1508",
    opacity: 0.9
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 156 34 C 162 22 166 15 160 8 C 150 0 140 10 136 22 C 146 18 152 24 156 34Z",
    fill: "#1a1508",
    opacity: 0.9
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 84 34 C 82 50 80 62 82 72 C 78 60 72 44 70 30 C 74 16 84 10 90 16 C 86 22 84 28 84 34Z",
    fill: "#12100a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 156 34 C 158 50 160 62 158 72 C 162 60 168 44 170 30 C 166 16 156 10 150 16 C 154 22 156 28 156 34Z",
    fill: "#12100a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 84 34 C 86 28 90 22 96 18",
    fill: "none",
    stroke: "#cc9930",
    strokeWidth: 1.2,
    opacity: 0.6
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 156 34 C 154 28 150 22 144 18",
    fill: "none",
    stroke: "#cc9930",
    strokeWidth: 1.2,
    opacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 155,
    r: 22,
    fill: "#0a0700",
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 155,
    r: 22,
    fill: "url(#l-sigil)",
    opacity: 0.8,
    filter: "url(#l-softglow)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "68,136 74,150 90,150 77,159 82,174 68,165 54,174 59,159 46,150 62,150",
    fill: "none",
    stroke: "#ffdd66",
    strokeWidth: 1.2,
    opacity: 0.85
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 155,
    r: 8,
    fill: "none",
    stroke: "#ffaa22",
    strokeWidth: 1,
    opacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 155,
    r: 3,
    fill: "#ffe880",
    opacity: 0.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 105,
    x2: 178,
    y2: 210,
    stroke: "#3a2e10",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 105,
    x2: 178,
    y2: 210,
    stroke: "#8a7030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 98,
    r: 14,
    fill: "#100a00"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 98,
    r: 14,
    fill: "url(#l-orb)",
    filter: "url(#l-glow)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 94,
    r: 4,
    fill: "#fffacc",
    opacity: 0.7
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 80 152 C 76 145 72 140 68 138 C 64 140 62 144 65 150 C 62 148 60 152 63 156 C 61 154 59 158 63 162 L 72 165Z",
    fill: "#9a8850",
    opacity: 0.8
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 160 148 C 164 142 168 138 172 136 C 176 138 178 142 175 148 C 178 146 180 150 177 154 C 179 152 181 156 177 160 L 168 162Z",
    fill: "#9a8850",
    opacity: 0.8
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 90 42 Q 120 30 150 42",
    fill: "none",
    stroke: "#cc7720",
    strokeWidth: 2,
    opacity: 0.35,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLich);
export default __webpack_public_path__ + "static/media/lich.89d29366836931ac4c4eda31264140d8.svg";
export { ForwardRef as ReactComponent };